import { Currency } from './../api/types'
import { defineStore } from 'pinia'
import { ServoConfig, WsServo } from '@/api/servo/types'
import { Categorys, Homelist, Announcement } from '@/api/home/type'
import { VideoDetail } from '@/api/video/types'
import { LoginUser } from '@/api/types'
import { GLOBAL_URL, ERROR_CODES, BLACK_LIST } from '@/enums'
import * as type from './types'
import type { SystemMessage } from '@/api/message/types'
import { getErrorMsg, getWsHeader, getChannel, getDeviceInfo, sort } from '@/utils'
import { showToast } from 'vant'
import { changeUserInfo } from '@/api'
import { Wallet } from '@/api/home/type'
import {
    Chat,
    HeaderMsg,
    SignParam,
    SignRes,
    Receive,
    Lamp,
    VipInfo,
    VipConfig,
    ChatTransferParam,
    VipRules,
    JackpotActionParam,
    RedfissionInfo,
    ActionParam,
} from './types'
import router from '@/router'
import { showCustomNotify } from '@/components/common/notifyAlert/useCustomNotify'
import i18n from '@/language'
import { useSubscript } from '@/components/notice/hook/useSubscribe'
import bus, { EVENT_KEY } from '@/utils/bus'
import webApp from '@twa-dev/sdk'
import { Log } from '@/api/log'
import dayjs from 'dayjs'
import { WS_SERVER, CURRENCY_LIST, LANGUAGE_LIST } from '@/enums'
import { Channel } from '@/api/wallet/type'
import { checkPwaSupport } from '@/components/transactionDetail/Utils'
/**
 * 用户信息
 * @methods setUserInfos 设置用户信息
 */
export const useBaseStore = defineStore('BetFugu_base', {
    state: (): Partial<{
        bodyHeight: number
        bodyWidth: number
        userInfo: Partial<LoginUser>
        wallet: Partial<Wallet>
        maskDialog: boolean
        maskDialogMode: string
        excludeNames: string[]
        showLogin: boolean
        token: string
        loading: boolean
        judgeValue: number
        homeRefresh: number
        servoConfig: Partial<ServoConfig>
        gameConfig: Partial<WsServo>
        gameserver: any
        isMuted: boolean
        lang: string
        systemNum: number
        transactionNum: number
        activeNum: number
        gameLogined: boolean
        loginCb: any[]
        SYSTEMList: Chat[]
        TRANSACTIONList: Chat[]
        chatList: {
            [key: string]: Chat[]
        }
        unReadCount: {
            [key: string]: number
        }
        shareId: number
        sharefrom: string
        webid: string
        okspinid: string
        okspinext: string
        partner: number
        link_id: string
        promote_url_id: string
        ntvfrom: string
        curSymbol: {
            [key: string]: string
        }
        signId: string
        videoCach: Map<string, string>
        newUser: boolean
        loginTime: number
        showVideoDrive: boolean
        showDownload: boolean
        tgInitData: { [key: string]: any }
        showMenu: boolean
        conneting: boolean
        wsList: string[]
        wsIdx: number
        tabData: Categorys[]
        gameList: Homelist
        homeShow: boolean
        showBuoy: boolean
        lampList: Lamp[]
        vipInfo: VipInfo
        vipConfig: VipConfig[]
        vipRules: VipRules
        reelsConfig: VideoDetail
        chargeDate: {
            [key: string]: string[]
        }
        signDate: {
            [key: string]: string[]
        }
        dramaStatus: {
            [key: string]: {
                like: number
                retweet: number
                favorite: number
            }
        }
        coinData: {
            date: number | number
            finish: boolean
        }
        buyVideoParam: null | {
            [key: string]: any
        }
        bonus: number
        closeBind: boolean
        depositOrder: string
        prevGameTag: string
        depositeChannel: Channel[]
        allChannels: Channel[] // 存储所有渠道数据（完整数据）
        paymentMethods: any[] // 存储支付方式数据
        announcementData: Announcement[]
        showAnnouncement: {
            [key: string]: string[]
        }
        redfissionInfo: RedfissionInfo
        transactionUnreadCount: number // 新增：交易消息未读数量（响应式）
        // 系统消息相关状态
        systemMessages: SystemMessage[] // 系统消息列表（缓存数据供各页面共享）
        // [key: string]: any
        urlParams: {
            [key: string]: string
        }
        currencyList: any[]
    }> => {
        return {
            bodyHeight: document.body.clientHeight as number,
            bodyWidth: document.body.clientWidth as number,
            userInfo: {},
            wallet: {},
            maskDialog: false,
            maskDialogMode: 'dark',
            excludeNames: ['notice'],
            showLogin: false,
            token: '', // 用户token
            loading: false,
            judgeValue: 20,
            homeRefresh: 60,
            servoConfig: {},
            gameConfig: {},
            gameserver: null,
            isMuted: true, // 视频静音
            lang: '',
            systemNum: 0, // 系统消息数量
            transactionNum: 0, // 交易消息数量
            activeNum: 0, // 活动消息数量
            gameLogined: false, // 是否登录到游戏服务器
            loginCb: [], // 未登录游戏服务时发出的请求
            SYSTEMList: [], // 系统消息列表
            TRANSACTIONList: [], // 交易消息列表
            chatList: {}, // 聊天信息
            unReadCount: {}, // 未读消息数量
            shareId: 0,
            sharefrom: '',
            webid: '',
            okspinid: '',
            okspinext: '',
            partner: 66666666,
            link_id: '',
            promote_url_id: '',
            ntvfrom: '',
            curSymbol: {}, // 货币符号配置
            signId: '',
            videoCach: new Map(),
            newUser: false,
            loginTime: 0, // 上次登录时间
            showVideoDrive: false,
            showDownload: true,
            tgInitData: {},
            showMenu: false,
            conneting: false,
            wsList: WS_SERVER,
            wsIdx: 0,
            tabData: [],
            gameList: [],
            homeShow: true,
            showBuoy: true,
            lampList: [],
            vipInfo: {},
            vipConfig: [],
            vipRules: [],
            reelsConfig: {},
            chargeDate: {},
            signDate: {},
            dramaStatus: {},
            coinData: {
                date: '',
                finish: false,
            },
            buyVideoParam: null,
            bonus: 0,
            closeBind: false,
            depositOrder: '',
            prevGameTag: '',
            depositeChannel: [],
            allChannels: [],
            paymentMethods: [],
            announcementData: [],
            showAnnouncement: {},
            redfissionInfo: {
                status: 0,
            },
            urlParams: {},
            transactionUnreadCount: 0, // 新增：交易消息未读数量初始值
            currencyList: CURRENCY_LIST,
            // 系统消息相关状态初始值
            systemMessages: [],
        }
    },
    getters: {
        // 未读消息数量
        noticeNum(state) {
            let totalUnreadCount = state.transactionUnreadCount + this.systemUnreadCount
            return totalUnreadCount
        },
        tabMenu(state) {
            const history = state.gameList?.history
            if (history?.length && history?.length > 0) {
                const tabData = [...state.tabData]
                // @ts-ignore
                tabData.splice(1, 0, {
                    name: 'Game_type_history',
                    picture: '',
                    type: 'history',
                })
                return tabData
            } else {
                const favorite = state.gameList?.favourite
                if (favorite?.length && favorite?.length > 0) {
                    const tabData = [...state.tabData]
                    // @ts-ignore
                    tabData.splice(1, 0, {
                        name: 'Game_type_history',
                        picture: '',
                        type: 'history',
                    })
                    return tabData
                }
            }
            return state.tabData
        },
        menuData(state) {
            const data = state.tabData.filter((item) => !['HOT', 'NEW'].includes(item.type.toUpperCase()))
            try {
                if (!data.length) {
                    return JSON.parse(localStorage.getItem('Home_TabData') || '')
                }
            } catch (error) {
                return []
            }
            localStorage.setItem('Home_TabData', JSON.stringify(data))
            return data
            // return state.tabData.filter((item) => !['HOT', 'NEW'].includes(item.type.toUpperCase()))
        },
        getVideoCache(state) {
            return (key) => state.videoCach.get(key)
        },
        // 货币符号
        cureencySymbol(state) {
            return (key = '') => {
                return state.curSymbol[key] || state.curSymbol[state.wallet?.currency]
            }
        },
        // currencyList(state) {
        //     return CURRENCY_LIST
        // },
        languageList() {
            return LANGUAGE_LIST.map((item) => {
                return {
                    ...item,
                    value: item.language.replace(/_([a-zA-Z])/g, (match, letter) => '-' + letter.toUpperCase()),
                }
            })
        },
        defaultCurrency() {
            if (this.wallet?.currency) {
                return CURRENCY_LIST.find((item) => item.currency === this.wallet?.currency)
            }
            return CURRENCY_LIST[0]
        },
        defaultLangguage() {
            return LANGUAGE_LIST[0]
        },
        showDown(state) {
            const pwaSupport = checkPwaSupport()
            const support = pwaSupport.serviceWorker && pwaSupport.webAppManifest
            return (
                !localStorage.getItem('__betfugu_858956856_data') &&
                state.showDownload &&
                !webApp.initData &&
                support &&
                !(
                    !!window.matchMedia('(display-mode: standalone)').matches ||
                    window.navigator.standalone ||
                    !!window.matchMedia('(display-mode: fullscreen)').matches
                ) &&
                !(getDeviceInfo().os === 'iOS' && window.navigator.standalone)
            )
        },
        isTg() {
            // return true
            return !!webApp.initData
        },
        // 是否是大区代理
        isAgent(state) {
            return state.token && state.userInfo?.agentid === state.userInfo?.uid
        },
        getWsServer() {
            return this.wsList[this.wsIdx++]
        },
        getBanner() {
            return this.gameList.banner
        },
        curVipConfig() {
            return this.vipConfig.find((item) => item.level === this.vipInfo.curLevel)
        },
        getApp() {
            if (this.isTg) {
                return 'telegram'
            }
            if (
                window.matchMedia('(display-mode: standalone)').matches ||
                (getDeviceInfo().os === 'iOS' && window.navigator.standalone) ||
                localStorage.getItem('__betfugu_858956856_data') ||
                localStorage.getItem('pwa-link-id')
            ) {
                return 'pwa'
            }
            return 'h5'
        },
        isPwa() {
            return (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) && getDeviceInfo().os !== 'iOS'
        },

        // ============== 系统消息相关计算属性 ==============
        /**
         * 计算系统消息未读数量
         */
        systemUnreadCount(state) {
            return state.systemMessages ? state.systemMessages.filter((msg) => !msg.isread).length : 0
        },

        /**
         * 获取需要弹窗的消息列表
         */
        popupMessages(state) {
            const unPopMessages = state.systemMessages ? state.systemMessages.filter((msg) => !msg.ispop) : []
            return unPopMessages
        },
    },
    actions: {
        setMenu(data) {
            this.showMenu = data
        },
        setvipInfo(data) {
            this.vipInfo = data.info
            this.vipConfig = data.config
            this.vipRules = data.rules
        },
        setHomeData(data?) {
            if (!data) {
                try {
                    data = JSON.parse(localStorage.getItem('Home_GameData') || '')
                } catch (error) {
                    return
                }
            }
            this.tabData = data.categorys
            this.gameList = data
            console.log(this.gameList, 'this.gameList')
            console.log(this.tabData, 'this.tabData')

            localStorage.setItem('Home_GameData', JSON.stringify(data))
        },
        getGameName(gamefirm) {
            return this.gameList.gamefirms[gamefirm].tag
        },
        // 获取厂商数组
        getGameFirms() {
            if (!this.gameList.gamefirms) return []

            // return Object.values(this.gameList.gamefirms).filter(firm => !firm.isstop)
            return Object.values(this.gameList.gamefirms)
        },
        getGamepagesHot() {
            return this.gameList.gamepages.Hot || []
        },
        getGameList(type) {
            const { gameconfigs, gamepages, gameStat, history, favourite } = this.gameList
            if (type === 'history') {
                return history
                    ?.sort((a, b) => b.time - a.time)
                    .map((game) => {
                        return { ...game, ...gameconfigs[game.gametag], ...gameStat[game.gametag] }
                    })
            } else if (type == 'favourite') {
                return favourite
                    ?.sort((a, b) => b.time - a.time)
                    .map((game) => {
                        return { ...game, ...gameconfigs[game.gametag], ...gameStat[game.gametag] }
                    })
            }

            // const selfGame = sort(gameselfpages[type])?.map((game) => {
            //     return { ...game, ...gameconfigs[game.gametag], ...gameStat[game.gametag] }
            // })

            const game = sort(gamepages[type])?.map((game) => {
                return { ...game, ...gameconfigs[game.gametag], ...gameStat[game.gametag] }
            })
            // ...selfGame,
            return [...game]
        },
        updatLamp(lamp) {
            if (lamp.title === 'SystemMaintain' || this.wallet.currency === lamp.cron) {
                this.lampList = [...this.lampList, lamp]
            }
        },
        clearLamp() {
            this.lampList = []
        },
        setTgData(data) {
            this.tgInitData = data
        },
        setVideoCache(key, val) {
            this.videoCach.set(key, val)
        },
        setInit(data) {
            const { currency, language } = data
            this.setWallet(currency)
            this.lang = language
            this.userInfo = { ...this.userInfo, curcurrency: currency.currency, curlanguage: language, guideCurrency: true, guideLanguage: true }
        },
        setCurSym() {
            const config = {}
            CURRENCY_LIST.forEach((item) => {
                config[item.currency] = item.clientcurrency
            })
            this.curSymbol = { ...config }
        },
        setMaskDialog(val) {
            this.maskDialog = val.state
            if (val.mode) {
                this.maskDialogMode = val.mode
            }
        },
        updateExcludeNames(val) {
            if (val.type === 'add') {
                if (!this.excludeNames.find((v) => v === val.value)) {
                    this.excludeNames.push(val.value)
                }
            } else {
                const resIndex = this.excludeNames.findIndex((v) => v === val.value)
                if (resIndex !== -1) {
                    this.excludeNames.splice(resIndex, 1)
                }
            }
        },
        // 设置服务器配置
        setServoConfig(val) {
            this.servoConfig = val
        },
        setGameConfig() {
            this.setCurSym()
        },
        setToken(token) {
            this.token = token
        },
        setNewUser(isNew) {
            this.showVideoDrive = this.newUser = isNew || false
        },
        setUserInfo(val) {
            this.userInfo = val
        },
        setWallet(val) {
            this.wallet = { ...this.wallet, ...val }
        },
        updateUserInfo(val) {
            this.userInfo = { ...this.userInfo, avatar: val }
        },
        setAnnouncementData(val: Announcement[]) {
            this.announcementData = val
        },
        logOut() {
            this.token = ''
            this.userInfo = {}
            this.unReadCount = {}
            this.chatList = {}
            this.SYSTEMList = []
            this.TRANSACTIONList = []
            // 🔧 新增：清理未读消息状态
            this.transactionUnreadCount = 0
            // 🔧 新增：清理系统消息状态
            this.clearSystemMessages()
            this.diconnect()
            bus.emit(EVENT_KEY.LOGOUT)
        },
        // 手动系统，充值，好友消息分发
        distributeMsg(msg) {
            if (getChannel(10001, this.userInfo.uid) === msg.channel) {
                return
            }

            const channel = msg.channel

            const isExit = this.chatList[channel]?.some((item) => item.id === msg.id)
            if (!isExit) {
                this.chatList[channel] = [...(this.chatList[channel] || []), { ...msg }]
            }
            // 🎯 只有在消息是新的、不是自己发送的、不是登录事件时才增加未读数量
            if (msg?.content.sender !== this.userInfo.uid && msg.event !== 'login' && !isExit) {
                // 区分处理系统消息和交易消息，跳过text事件
                if (channel.includes('20000') && msg.event !== 'text') {
                    // 交易消息：更新响应式状态
                    this.transactionUnreadCount += 1
                    // 同时更新localStorage作为持久化存储
                    this.updateTransactionUnreadCountStorage()
                    // console.log('✅ 交易消息未读+1:', channel, 'total:', this.transactionUnreadCount)
                } else {
                    // 系统消息：更新unReadCount
                    this.unReadCount[channel] = (this.unReadCount[channel] || 0) + 1
                    // console.log('✅ 系统消息未读+1:', channel, 'total:', this.unReadCount[channel])
                }
            }

            bus.emit(EVENT_KEY.MESSAGE_UPDATE, msg)
            const isNotify = msg?.event === 'notify'
            if (channel.includes('20000') || isNotify) {
                bus.emit(EVENT_KEY.TRANSACTION_STATUS_UPDATED)
                const { translateTtoText } = useSubscript('')
                showCustomNotify({
                    message: i18n.global.t(msg.content.text, translateTtoText(msg)),
                    duration: 3000,
                    onClick: () => {
                        router.push({
                            path: '/message',
                        })
                    },
                })
            }
        },
        diconnect() {
            this.wsIdx = 0
            if (this.gameserver) {
                this.gameserver.disconnect(-1, 'logout')
                this.gameserver.cleanup()
                localStorage.removeItem('current.session')
                this.gameserver = null
            }
        },
        // 请求封装
        async request<T>(url, params = {}, conf): Promise<T> {
            const config = Object.assign({ loading: true, tip: true }, conf)
            console.log(params, '长链接请求 ', url)
            return new Promise((resolve) => {
                // 处理刷新页面时 未登录游戏服务时发送的请求
                if (!this.gameLogined && !BLACK_LIST.includes(url)) {
                    this.loginCb.push(resolve)
                    return
                }
                resolve(0)
            })
                .then(() => {
                    // this.gameserver && config.loading && (this.loading = true)
                    return this.gameserver
                        ?.request(url, params)
                        .then((response) => {
                            config.loading && (this.loading = false)
                            console.log(response, '长链接返回 ', url, params)
                            if (!response) {
                                this.gameserver.handleClosed()
                                return Promise.reject('soket断连无返回值')
                            }

                            if (response.code && response.code !== ERROR_CODES.OK) {
                                if (config.tip) {
                                    const errorTip = getErrorMsg(url, response.code)
                                    if (errorTip) {
                                        showToast({
                                            message: i18n.global.t(errorTip),
                                            zIndex: 4000,
                                        })
                                    }
                                }
                            }
                            return response
                        })
                        .catch((e) => {
                            console.log(e)
                            this.loading = true
                        })
                })
                .catch(() => {
                    this.loading = true
                })
        },
        // 获取个人信息
        async getProfile() {
            const response: any = await this.request(GLOBAL_URL.ProfilesAsync, {})
            this.userInfo = response.metadata
        },
        // 更改个人信息
        async changeUserInfo(pramas: type.ChangeUserInfo) {
            const response: any = await changeUserInfo(pramas)
            if (response.code === ERROR_CODES.OK) {
                this.userInfo = { ...this.userInfo, nickname: response.pro.nickname }
            }
            return response
        },
        // 绑定手机号
        async bindPhone(params: type.BindPhone) {
            const response: any = await this.request(GLOBAL_URL.BindPhone, params)
            if (response.code === ERROR_CODES.OK) {
                this.getProfile()
            }
            return response
        },
        // 绑定邀请人
        async bindInviter(params: type.BindInviter, conf = {}) {
            const response: any = await this.request(GLOBAL_URL.ShareInviteBind, params, conf)
            if (response?.code === 200) {
                this.getProfile()
            }
            return response
        },
        // 游戏订阅
        async gameSubscribe(params: type.GameSubscribe) {
            return this.request(GLOBAL_URL.GameSubscribe, params, { tip: true })
        },
        async gameUnSubscribe() {
            return this.request(GLOBAL_URL.GameUnSubscribe)
        },
        // 获取vip信息
        async getVipInfo(loading = true, tip = true) {
            return this.request(
                GLOBAL_URL.Vip,
                {},
                {
                    tip,
                    loading,
                }
            )
        },
        // vip领取
        async pickVipRewards(params = {}) {
            return this.request(GLOBAL_URL.PickRewads, params)
        },

        async triggerVip(params = {}) {
            return this.request(GLOBAL_URL.triggerVip, params)
        },
        async bind() {
            if (this.shareId) {
                const res = await this.bindInviter(
                    {
                        shareid: this.shareId, // 邀请人id
                        auto: true, //是否自动绑定
                        from: this.sharefrom, //渠道来源
                    },
                    { loading: false, tip: false }
                )
                if (res?.code === 200) {
                    this.$patch({
                        shareId: 0,
                    })
                }
            }
        },
        async gameLogOut() {
            if (!this.gameserver) {
                return
            }
            this.gameserver.disconnect(-1, 'logout')
            this.gameserver.cleanup()
            localStorage.removeItem('current.session')
            this.gameserver = null
        },

        async SessionLogin() {
            Log({
                event: 'ws_login',
                content: {
                    ctime: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
                    retryCounter: this.gameserver.retryCounter,
                    host: this.gameserver._remote.href,
                },
            })
            const response: any = await this.request(
                GLOBAL_URL.SessionLogin,
                {
                    token: this.token,
                    package: getWsHeader(),
                },
                { tip: false }
            )

            if (response.code === ERROR_CODES.Gone) {
                this.logOut()
                router.push('/login')
                return
            } else if (response.code === 100) {
                // this.gameLogOut()
                // this.gameserver.emit('reconnect')
                this.gameserver.handleClosed()
                return
            }
            this.token = ''
            const { newtoken, metadata, items } = response

            //分享绑定
            this.bind()
            this.userInfo = metadata
            this.token = newtoken
            this.wallet = { ...items, currency: metadata.curcurrency }
            this.gameLogined = true

            // 🎯 登录后初始化交易消息未读数量
            this.initTransactionUnreadCount()
            if (this.loginCb.length) {
                this.loginCb.forEach((cb) => {
                    cb && cb()
                })
                this.loginCb = []
            }
            Log({
                event: 'ws_logined',
                content: {
                    ctime: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
                    retryCounter: this.gameserver.retryCounter,
                    host: this.gameserver._remote.href,
                },
            })

            //加载KOL_SDK
            // this.loadKolSdk()

            //加载热力引擎sdk
            this.loadSESdk()
        },
        loadKolSdk() {
            const userinfo = this.userInfo
            if (!userinfo.webid) return
            const jsurl = 'https://static.taer.xyz/public/lib/dau.mjs'
            const script = document.createElement('script')
            script.src = jsurl
            script.async = true
            script.onerror = () => {
                console.error('Failed to load script: ', jsurl)
            }
            script.onload = () => {
                // @ts-ignore
                TasyeeCPSSDk.reportDau({
                    uid: userinfo.uid,
                    webId: userinfo.webid,
                })
            }
            document.head.appendChild(script)
        },
        async loadSESdk() {
            const userinfo = this.userInfo
            if (!userinfo.webid || userinfo.webid !== 'solareg') return
            // 动态导入方式
            async function loadSESDK() {
                try {
                    const SESDK = await import('../web-us-sesdk-es')
                    return SESDK.default || SESDK
                } catch (error) {
                    console.error('Failed to load SESDK:', error)
                    throw error
                }
            }
            // @ts-ignore
            let SESDK = window.SESDK
            if (!SESDK) {
                SESDK = await loadSESDK()
            }
            if (!SESDK) return
            SESDK.prevInit('605b72085e60362e')
            SESDK.init({
                appKey: '605b72085e60362e',
                userId: '5d5aa21fccf1542a',
            })

            SESDK.login(userinfo.uid)
        },
        // 提现
        async payOut(params: type.PayOut): Promise<type.PayOutRes> {
            return this.request(GLOBAL_URL.PayOut, params)
        },
        async payOutEarn(params: type.PayOut): Promise<type.PayOutRes> {
            return this.request(GLOBAL_URL.PayOutEarn, params)
        },
        // 重新进入游戏
        async Rejoingames() {
            return this.request(GLOBAL_URL.Rejoingames, {})
        },
        // 礼物兑换码
        async exchangeGiftCdk(cdkcode: string) {
            return this.request(GLOBAL_URL.GiftCdk, { cdkcode })
        },
        //   查询领取bounus
        async QueryBonuse(type = 0) {
            return this.request(GLOBAL_URL.QueryBonuse, { type }, { loading: false })
        },
        // 获取未读数据
        async getMsgUnread(loading = false) {
            return this.request(GLOBAL_URL.GetFriendsMeta, {}, { loading }).then((res) => {
                if (res.code === 200) {
                    this.unReadCount = {}
                    // console.log('所有未读消息res.unreadmessages', res.unreadmessages)
                    Object.keys(res.unreadmessages || {}).forEach((channel) => {
                        if (channel !== getChannel(10001, this.userInfo.uid)) {
                            const [, sender, reciever] = channel.match(/^(\d+):(\d+)$/)
                            const code = this.userInfo.uid == sender ? `${reciever}:${sender}` : `${sender}:${reciever}`
                            this.unReadCount[code] = res.unreadmessages[channel]
                        }
                    })
                    this.activeNum = res.activityzone || 0
                }
                return res
            })
        },
        // 获取最近20条数据
        async getHot20Msg(channel) {
            return await this.request(GLOBAL_URL.GetHotMsg, { channels: [channel] }, { loading: false })
        },
        async getChatHis({ channel, id, size = 10 }) {
            return await this.request(GLOBAL_URL.GetHisMsg, { channel, id, size }, { loading: false })
        },
        async sendText(params) {
            return this.request(GLOBAL_URL.SendText, params, { loading: false })
        },

        //  消息订阅
        async subscribe(channel) {
            console.trace()
            return this.request(GLOBAL_URL.FriendsSubscribe, { channel }, { loading: false })
        },
        // 取消消息订阅
        async deSubscribe(channel) {
            return this.request(GLOBAL_URL.FriendsUnsubscribe, { channel }, { loading: false })
        },
        async Beanexchange(count: string) {
            return this.request(GLOBAL_URL.Beanexchange, { count: +count })
        },
        async getHeadermessage(pramas): Promise<HeaderMsg> {
            return this.request(GLOBAL_URL.Headermessage, pramas)
        },
        // 获取签到活动
        async getSignEvent(params: SignParam, tip = true, loading = true): Promise<SignRes> {
            return this.request(GLOBAL_URL.Sign, params, { tip, loading })
        },

        // 获取Jackpot相关数据的通用方法
        async getJackpotAction(params: JackpotActionParam, tip = true, loading = true) {
            return this.request(GLOBAL_URL.JackpotAction, params, { tip, loading })
        },
        // 开启活动
        async actionEvent(params: ActionParam, tip = true, loading = true): Promise<SignRes> {
            return this.request(GLOBAL_URL.action, params, { tip, loading })
        },
        async ReceiveRewards(params: Receive, loading: boolean = true): Promise<{ code: number; awards: { [key: string]: any } }> {
            return this.request(GLOBAL_URL.ReceiveRewards, params, { loading })
        },
        async OrderCancel(orderid: string) {
            return this.request(GLOBAL_URL.OrderCancel, { orderid })
        },
        // 聊天交易
        async SendChatGold(params: ChatTransferParam) {
            return this.request(GLOBAL_URL.ChatTransfer, params)
        },
        /**
         * 获取实时可领取bonus
         * hybird.player.bonusexchange
         * @param msg {type:0,1 }  0:查询，1:领取
         * @return
         * {code: ERROR_CODES.OK, gold:0}
         * {code: ERROR_CODES.OK, gold:exchange}
         */
        async getBonus(type: number, loading = true) {
            return this.request(GLOBAL_URL.BonusExchange, { type }, { loading })
        },
        async deleteMessage(channle: string, id: number) {
            return this.request(GLOBAL_URL.DeleteMessage, { channle: channle, id: id })
        },

        /**
         * 获取指定用户的未读交易消息数量（从本地存储）
         * @param userId 用户ID，不传则使用当前用户
         * @returns 未读消息数量
         */
        getUnreadTransactionCount() {
            const uid = this.userInfo?.uid
            if (!uid) {
                return 0
            }
            try {
                const count = JSON.parse(localStorage.getItem(`unReadTransactionMessages_${uid}`))
                return count || 0
            } catch (error) {
                return 0
            }
        },

        /**
         * 更新交易消息未读数量（响应式状态）
         * @param count 未读数量
         */
        updateTransactionUnreadCount(count: number) {
            this.transactionUnreadCount = count
            this.updateTransactionUnreadCountStorage()
        },

        /**
         * 更新localStorage中的交易消息未读数量
         */
        updateTransactionUnreadCountStorage() {
            const uid = this.userInfo?.uid
            if (uid) {
                localStorage.setItem(`unReadTransactionMessages_${uid}`, JSON.stringify(this.transactionUnreadCount))
            }
        },

        /**
         * 初始化交易消息未读数量（从localStorage恢复）
         */
        initTransactionUnreadCount() {
            const count = this.getUnreadTransactionCount()
            this.transactionUnreadCount = count
        },

        // ============== 系统消息状态管理方法 ==============
        /**
         * 设置系统消息数据
         * @description 由组件调用API获取数据后，存储到Store中供全局使用
         */
        setSystemMessages(messages: SystemMessage[]): void {
            this.systemMessages = messages
        },

        /**
         * 更新单条消息状态
         * @description 消息已读后更新本地状态
         */
        updateMessageReadStatus(messageId: number): void {
            const messageIndex = this.systemMessages.findIndex((msg) => msg.id === messageId)
            if (messageIndex !== -1) {
                // 使用数组替换的方式确保响应式更新
                this.systemMessages[messageIndex] = {
                    ...this.systemMessages[messageIndex],
                    isread: true,
                }
            }
        },
        /**
         * 更新消息已弹框状态
         * @description 消息已弹框后更新本地状态
         */
        updateMessagePoppedStatus(messageId: number): void {
            const messageIndex = this.systemMessages.findIndex((msg) => msg.id === messageId)
            if (messageIndex !== -1) {
                this.systemMessages[messageIndex] = {
                    ...this.systemMessages[messageIndex],
                    ispop: true, // 标记为已弹框，不再需要弹窗
                }
            }
        },

        /**
         * 批量更新消息已读状态
         * @description 批量已读后更新本地状态
         */
        updateBatchMessageReadStatus(messageIds: number[]): void {
            // 使用数组替换的方式确保响应式更新
            this.systemMessages = this.systemMessages.map((msg) => {
                if (messageIds.includes(msg.id)) {
                    return { ...msg, isread: true }
                }
                return msg
            })
        },

        /**
         * 添加新的系统消息（实时推送）
         * @description 长链接推送新消息时调用
         */
        addSystemMessage(message: SystemMessage): void {
            const existingIndex = this.systemMessages.findIndex((msg) => msg.id === message.id)

            if (existingIndex >= 0) {
                // 更新现有消息
                this.systemMessages[existingIndex] = message
            } else {
                // 添加新消息到列表头部
                this.systemMessages.unshift(message)
            }
        },

        /**
         * 清理系统消息数据
         * @description 用户登出时清理状态
         */
        clearSystemMessages(): void {
            this.systemMessages = []
        },
        getPayoutRate(cny = 0, feepercent = 0, fee = 0) {
            return Number((Number(feepercent) * Number(cny) + Number(fee)).toFixed(4))
        },
    },
    persist: {
        key: 'BetFugu_base',
        storage: window.localStorage,
        paths: [
            'userInfo',
            'token',
            'lang',
            'wallet',
            'curSymbol',
            'newUser',
            'loginTime',
            'showVideoDrive',
            'chargeDate',
            'reelsConfig',
            'dramaStatus',
            'closeBind',
            'depositOrder',
            'signDate',
            'prevGameTag',
            'showAnnouncement',
        ],
    },
})
